import { css, setColor_25476d, setFontSize_13px, setFontWeight600, setProps, styled } from "theme";

interface SFilterInputTitleProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFilterInputTitleProps>(({ isArabic }) => isArabic)(css`
  text-align: right;
`);

export const SFilterInputTitle = styled.div<SFilterInputTitleProps>`
  margin-top: 8px;
  margin-bottom: 8px;

  ${isArabicLang};
  ${setFontSize_13px};
  ${setFontWeight600};
  ${setColor_25476d};
`;
